import { useState } from 'react';
import { getValueOnLocalStorage, setValueOnLocalStorage } from '../utils/localStorage';

const KEY = 'hideDiceChat';

export function useHideChatSetting() {
  const [hideChat, setHide] = useState(() => {
    const stored = getValueOnLocalStorage(KEY);
    return stored === null ? false : stored;
  });

  const setHideChat = (val) => {
    setHide(val);
    setValueOnLocalStorage(KEY, val);
  };

  return [hideChat, setHideChat];
}
